import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import * as cartActionCreators from '../../../actions/cart';
let allActionCreators = Object.assign({}, cartActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';

class DiamondPendants extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      price1: 650,
      price2: 700,
      price3: 1200,
      price4: 690,
      price5: 990,

      carat1: '',
      carat2: '',
      carat3: '',
      carat4: '',
      carat5: '',

      errorCode: '',

      loadingButton: null,
    }
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  getCW1() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.25 ctw',
        value: 650,
      },
      {
        display: '0.30 ctw',
        value: 850,
      },
      {
        display: '0.50 ctw',
        value: 1500,
      },
      {
        display: '0.70 ctw',
        value: 2400,
      },
      {
        display: '1.00 ctw',
        value: 4500,
      },
    ];
  }

  getCW2() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.25 ctw',
        value: 700,
      },
      {
        display: '0.30 ctw',
        value: 900,
      },
      {
        display: '0.50 ctw',
        value: 1600,
      },
      {
        display: '0.70 ctw',
        value: 2500,
      },
      {
        display: '1.00 ctw',
        value: 4500,
      },
    ];
  }

  getCW3() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.30 ctw',
        value: 1200,
      },
      {
        display: '0.50 ctw',
        value: 1950,
      },
      {
        display: '0.70 ctw',
        value: 3000,
      },
      {
        display: '1.00 ctw',
        value: 5400,
      },
      {
        display: '1.50 ctw',
        value: 11500,
      },
    ];
  }

  getCW4() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.25 ctw',
        value: 690,
      },
      {
        display: '0.50 ctw',
        value: 1210,
      },
      {
        display: '0.75 ctw',
        value: 2090,
      },
      {
        display: '1.00 ctw',
        value: 3260,
      },
      {
        display: '1.50 ctw',
        value: 5600,
      },
      // {
      //   display: '2.00 ctw',
      //   value: 11000,
      // },
    ];
  }

  getCW5() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.33 ctw',
        value: 990,
      },
      {
        display: '0.50 ctw',
        value: 1280,
      },
      {
        display: '0.80 ctw',
        value: 2120,
      },
      // {
      //   display: '0.90 ctw',
      //   value: 2850,
      // },
      {
        display: '1.00 ctw',
        value: 3470,
      },
      {
        display: '1.50 ctw',
        value: 5300,
      },
    ];
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeCarat1(evt) {
    this.setState({ carat1: evt.target.value }, () => {
      if(this.state.errorCode == 'carat1') {
        this.setState({ errorCode: '' });
      }
    });
  }

  changeCarat2(evt) {
    this.setState({ carat2: evt.target.value }, () => {
      if(this.state.errorCode == 'carat2') {
        this.setState({ errorCode: '' });
      }
    });
  }

  changeCarat3(evt) {
    this.setState({ carat3: evt.target.value }, () => {
      if(this.state.errorCode == 'carat3') {
        this.setState({ errorCode: '' });
      }
    });
  }

  changeCarat4(evt) {
    this.setState({ carat4: evt.target.value }, () => {
      if(this.state.errorCode == 'carat4') {
        this.setState({ errorCode: '' });
      }
    });
  }

  changeCarat5(evt) {
    this.setState({ carat5: evt.target.value }, () => {
      if(this.state.errorCode == 'carat5') {
        this.setState({ errorCode: '' });
      }
    });
  }

  getCaratWeight(sku, price) {
    if(!sku) {
      return '';
    }

    let dataBlock = [];

    switch(sku) {
      case 'DPDRD':
        dataBlock = this.getCW1();
        break;
      case 'DPDPS':
        dataBlock = this.getCW2();
        break;
      case 'DPDHA':
        dataBlock = this.getCW3();
        break;
      case 'DPD3RD':
        dataBlock = this.getCW4();
        break;
      case 'DPD3PS':
        dataBlock = this.getCW5();
        break;
    }

    for(let i = 0; i < dataBlock.length; i++) {
      if(dataBlock[i].value == price) {
        return dataBlock[i].display;
      }
    }
    return '';
  }

  getPendantDesc(sku, price) {

    // Diamond Solitaire Pendant (INTERNAL NOTE FOR WEST: for Round or Princess only)
    // Shape:
    // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
    // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all pendants will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
    // Color: The average color range for pendants is I – J
    // Clarity: The average clarity range for pendants is SI2 - I1
     

    // Round Diamond Halo Pendant
    // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
    // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all pendants will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
    // Color: The average color range for pendants is I – J
    // Clarity: The average clarity range for pendants is SI2 - I1
     

    // Graduating Three Stone Pendant INTERNAL NOTE FOR WEST: for Round or Princess only)
    // Shape:
    // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
    // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all pendants will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
    // Color: The average color range for pendants is I – J
    // Clarity: The average clarity range for pendants is SI2 - I1

    let diaDesc = '';

    if(sku == 'DPDRD' || sku == 'DPD3RD') {
      diaDesc += '<B>Shape</B>: Round<br />';
    } else if(sku == 'DPDPS' || sku == 'DPD3PS') {
      diaDesc += '<B>Shape</B>: Princess<br />';
    }

    let caratWeight = this.getCaratWeight(sku, price);
    if(caratWeight) {
      diaDesc += ('<B>Carat Weight</B>: ' + caratWeight + ' (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)<br />');
    }

    diaDesc += '<B>Metal type</B>: 14 karat white gold<br /><B>Color</B>: The average color range for pendants is I – J<br /><B>Clarity</B>: The average clarity range for pendants is SI2 - I1';
    return diaDesc;
  }

  addToCart(sku, caratPrice, code) {
    
    if(!this.state[code]) {
      this.setState({ errorCode: code });
      return;
    }

    this.setState({ loadingButton: code });

    // export function cartAddDiamondJewelry(stockNo, sku, carat_mod, diamond_desc) {
    this.props.cartAddDiamondJewelry(sku, caratPrice, this.getPendantDesc(sku, caratPrice))
    .then((resp) => {
      console.log(resp);
      this.externalNav('checkout/cart');
    })
    .catch((errResp) => {
      this.setState({ loadingButton: null });
    });
  }

  render() {
    return <div className='DiamondPendants DiamondPage'>
      <div className='dpBreadcrumbs'>Diamond Pendants</div>
      <div className='dpProductsWrapper'>
        <div className='dpProduct'>
          <div className='dpItemWrapper'>
            <div className='dpProductImg'>
              <img src='https://ddw2.diamondsdirect.com/img/diamondpages/PrincessPendantRound-a.jpg' />
            </div>
            <div className='dpProductTitle'>Round Solitaire Pendant</div>
            <div className='dpProductConfigElement'>
              {this.state.errorCode == 'carat1' ?
                <div className='dpErrorMessage'>Please select a carat weight</div> :
                null
              }
              <RhinoSelect
                options={this.getCW1()}
                value={this.state.carat1}
                changeMethod={::this.changeCarat1}
                rootClass='productSelect' />
            </div>
            <div className='dpBr'></div>
            <div className='dpPrice'>${(this.state.carat1 ? this.state.carat1 : this.state.price1).toLocaleString()}</div>
            {this.state.loadingButton == 'carat1' ?
              <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
              <div className='dpAddToCart' onClick={() => this.addToCart('DPDRD', this.state.carat1 ? this.state.carat1 : this.state.price1, 'carat1')}><div>Add to Cart</div></div>
            }
          </div>
        </div>

        <div className='dpProduct'>
          <div className='dpItemWrapper'>
            <div className='dpProductImg'>
              <img src='https://ddw2.diamondsdirect.com/img/diamondpages/PrincessSolPendant-a.jpg' />
            </div>
            <div className='dpProductTitle'>Princess Solitaire Pendant</div>
            <div className='dpProductConfigElement'>
              {this.state.errorCode == 'carat2' ?
                <div className='dpErrorMessage'>Please select a carat weight</div> :
                null
              }
              <RhinoSelect
                options={this.getCW2()}
                value={this.state.carat2}
                changeMethod={::this.changeCarat2}
                rootClass='productSelect' />
            </div>
            <div className='dpBr'></div>
            <div className='dpPrice'>${(this.state.carat2 ? this.state.carat2 : this.state.price2).toLocaleString()}</div>
            {this.state.loadingButton == 'carat2' ?
              <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
              <div className='dpAddToCart' onClick={() => this.addToCart('DPDPS', this.state.carat2 ? this.state.carat2 : this.state.price2, 'carat2')}><div>Add to Cart</div></div>
            }
          </div>
        </div>

        <div className='dpProduct'>
          <div className='dpItemWrapper'>
            <div className='dpProductImg'>
              <img src='https://ddw2.diamondsdirect.com/img/diamondpages/products2/halo_pendant.jpg' />
            </div>
            <div className='dpProductTitle'>Halo Pendant</div>
            <div className='dpProductConfigElement'>
              {this.state.errorCode == 'carat3' ?
                <div className='dpErrorMessage'>Please select a carat weight</div> :
                null
              }
              <RhinoSelect
                options={this.getCW3()}
                value={this.state.carat3}
                changeMethod={::this.changeCarat3}
                rootClass='productSelect' />
            </div>
            <div className='dpBr'></div>
            <div className='dpPrice'>${(this.state.carat3 ? this.state.carat3 : this.state.price3).toLocaleString()}</div>
            {this.state.loadingButton == 'carat3' ?
              <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
              <div className='dpAddToCart' onClick={() => this.addToCart('DPDHA', this.state.carat3 ? this.state.carat3 : this.state.price3, 'carat3')}><div>Add to Cart</div></div>
            }
          </div>
        </div>

        <div className='dpProduct'>
          <div className='dpItemWrapper'>
            <div className='dpProductImg'>
              <img src='https://ddw2.diamondsdirect.com/img/diamondpages/products/pendant4.jpg' />
            </div>
            <div className='dpProductTitle'>Graduated 3-Stone Round Pendant</div>
            <div className='dpProductConfigElement'>
              {this.state.errorCode == 'carat4' ?
                <div className='dpErrorMessage'>Please select a carat weight</div> :
                null
              }
              <RhinoSelect
                options={this.getCW4()}
                value={this.state.carat4}
                changeMethod={::this.changeCarat4}
                rootClass='productSelect' />
            </div>
            <div className='dpBr'></div>
            <div className='dpPrice'>${(this.state.carat4 ? this.state.carat4 : this.state.price4).toLocaleString()}</div>
            {this.state.loadingButton == 'carat4' ?
              <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
              <div className='dpAddToCart' onClick={() => this.addToCart('DPD3RD', this.state.carat4 ? this.state.carat4 : this.state.price4, 'carat4')}><div>Add to Cart</div></div>
            }
          </div>
        </div>

        <div className='dpProduct'>
          <div className='dpItemWrapper'>
            <div className='dpProductImg'>
              <img src='https://ddw2.diamondsdirect.com/img/diamondpages/products/pendant5.jpg' />
            </div>
            <div className='dpProductTitle'>Graduated 3-Stone Princess Pendant</div>
            <div className='dpProductConfigElement'>
              {this.state.errorCode == 'carat5' ?
                <div className='dpErrorMessage'>Please select a carat weight</div> :
                null
              }
              <RhinoSelect
                options={this.getCW5()}
                value={this.state.carat5}
                changeMethod={::this.changeCarat5}
                rootClass='productSelect' />
            </div>
            <div className='dpBr'></div>
            <div className='dpPrice'>${(this.state.carat5 ? this.state.carat5 : this.state.price5).toLocaleString()}</div>
            {this.state.loadingButton == 'carat5' ?
              <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
              <div className='dpAddToCart' onClick={() => this.addToCart('DPD3PS', this.state.carat5 ? this.state.carat5 : this.state.price5, 'carat5')}><div>Add to Cart</div></div>
            }
          </div>
        </div>

        <div className='dpProduct'>
          <div className='dpItemWrapper'>
            <div className='dpProductImg'>
              <img src='https://ddw2.diamondsdirect.com/img/diamondpages/pendants_icon.svg' />
            </div>
            <div className='dpProductTitle'>CUSTOM PENDANTS</div>
            <div className='dpBr'></div>
            <div className='dpText'>Diamonds Direct can handcraft a diamond pendant to meet any expectations! For certified diamonds, fancy colors, or fancy shape diamonds our diamond experts can help select diamonds to make the perfect pendant.</div>
            <div className='dpAddToCart' onClick={() => this.internalNav('custom-design')}><div>Create Custom</div></div>
          </div>
        </div>


      </div>
      <div className='dpLegal'>*Please note: All diamond pendants are set in 14 karat white gold.<br />The average color range is I - J and the average clarity range SI2 - I1<br />The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%.</div>
    </div>;
	}
}
export default DiamondPendants;

function mapStateToProps(state) {
  return {

  };
}

export const DiamondPendantsContainer = connect(
  mapStateToProps,
  allActionCreators
)(DiamondPendants);


// WEBPACK FOOTER //
// ./src/components/views/diamondpages/DiamondPendants.jsx